export default "__VITE_ASSET__DJ64Vr4y__"